import { FormObjType } from "DataTypes/Form";
import DateTime from "Utils/DateTime";

export const AddEditForm: FormObjType[] = [
  {
    id: "name",
    label: "Problem Name",
    placeholder: "Enter problem name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeholder: "Select start date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  },
  {
    id: "endDate",
    label: "End Date",
    placeholder: "Select end date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  },
  {
    id: "comment",
    label: "Comments",
    placeholder: "Enter comments",
    boxType: "input",
    boxSize: 12,
    validatetype: "any",
    enableFormLoad: true,
  }
];

export const AddEditForm2: FormObjType[] = [
  {
    id: "code",
    label: "Code",
    placeholder: "Enter code",
    boxType: "input",
    boxSize: 4,
    validatetype: "icd-code",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "name",
    label: "Code Name",
    placeholder: "Enter code name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "codeSystemName",
    label: "Code System Name",
    placeholder: "Enter code system name",
    boxType: "input",
    inputVal: "ICD-10-CM",
    boxSize: 4,
    validatetype: "any",
    readOnly: true,
    enableFormLoad: true,
  },
]